import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandFactoryService } from '../../../core/service/factory/command-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { OtherContract } from '../../model/other-contract';
import { ContractService } from '../../service/base/contract';
import { ActivatedRoute } from '@angular/router';
import { ApproveContractCommandHandler } from '../../service/command/approve-contact-command-handler.service';
import { ContractCommandHandlerResolver } from '../../service/command/contract-command-handler-resolver.service';
import { OtherContractCommandFactory } from '../../service/command/factory/other-contract-command-factory.service';
import { PrintContractCommandHandler } from '../../service/command/print-contract-command-handler.service';
import { ShowLeaseAgreementInvoicesCommandHandler } from '../../service/command/show-lease-agreement-invoices-command-handler';
import { TerminateContractCommandHandler } from '../../service/command/terminate-contract-command-handler.service';
import { WithdrawApprovalCommandHandler } from '../../service/command/withdraw-approval-command-handler.service';
import { WithdrawTerminationCommandHandler } from '../../service/command/withdraw-termination-command-handler.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { OtherContractService } from '../../service/data/other-contract.service';
import { VoidContractCommandHandler } from '../../service/command/void-contract-command-handler.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { ESignLeaseAgreementContractCommandHandler } from '../../service/command/esign-lease-agreement-document-command-handler.service';
import { UserAccountService } from '../../../common/service/user-account.service';
import { ESignKeyRecieptCommandHandler } from '../../service/command/esign-key-reciept-document-command-handler.service';
import { ContractManagerPagedBase } from '../base/contract-manager-paged';
import { CustomPropertyService } from '../../service/data/custom-property.service';
import { CustomPropertyVisibilityType } from '../../model/const/enums';
import { CustomPropertyHelper } from '../../helper/customproperties-helper';
import { PropertyService } from '../../service/data/property.service';
import { CompanyService } from '../../service/data/company.service';

@Component({
    selector: 'app-other-contract-manager',
    templateUrl: 'other-contract-manager.component.html',
    styleUrls: ['other-contract-manager.component.scss', './../../../core/component/object-manager/object-manager.template.scss'],
    providers: [
        ApproveContractCommandHandler,
        ContractCommandHandlerResolver,
        ShowLeaseAgreementInvoicesCommandHandler,
        TerminateContractCommandHandler,
        VoidContractCommandHandler,
        ESignLeaseAgreementContractCommandHandler,
        ESignKeyRecieptCommandHandler,
        WithdrawApprovalCommandHandler,
        WithdrawTerminationCommandHandler,
        PrintContractCommandHandler,
        { provide: ContractService, useExisting: OtherContractService },
        { provide: CommandFactoryService, useClass: OtherContractCommandFactory },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OtherContractManagerComponent extends ContractManagerPagedBase<OtherContract> {
  constructor(
    activatedRoute: ActivatedRoute,
    columnDefinitionService: ColumnDefinitionService,
    dispatcher: CommandDispatcher,
    handlerResolver: ContractCommandHandlerResolver,
    service: OtherContractService,
    errorHandler: MessageService,
    userAccount: UserAccountService,
    navigationService: NavigationService,
    private readonly _customPropertyService: CustomPropertyService,
    private readonly _ch: CustomPropertyHelper,
    private readonly companyService: CompanyService,
    private readonly propertyService: PropertyService
  ) {
    super(
      service,
      dispatcher,
      handlerResolver,
      errorHandler,
      navigationService,
      userAccount,
      companyService,
      propertyService,
      activatedRoute
    );
    this.columnDefinition = columnDefinitionService.create('OtherContract');
    this.title = 'LEASE_AGREEMENT.OTHER_LIST_HEADER';
    this.AddSubscription(
      userAccount.current.subscribe({
        next: account => {
          if (account.hasLeaseAgreementWriteAccess()) {
            this.addContextMenuItemDefinition('LEASE_AGREEMENT.COMMAND.VOID', leaseAgreementCommand.void);
          }
          this.addListMenuItem('COMMON.EXCEL_EXPORT', leaseAgreementCommand.exportNoPersonalData);
          this.addListMenuItem('COMMON.COMMAND.EXPORT_EXCEL_WITH_PERSONAL_DATA', leaseAgreementCommand.export);
        },
      })
    );
    let index = this.contextMenuDefinition.findIndex(item => item.commandId == leaseAgreementCommand.sendForEsignDocument);
    if (index >= 0) this.contextMenuDefinition.splice(index, 1);
  }

  override filterInternal(filterState: any): void {
    this._ch.applyCustomPropertyFilters(filterState);
  }

  addFilterDefinitions(definition: any) {
    this._customPropertyService.getList().subscribe(customProperties => {
      super.addFilterDefinitions(definition);

      const customPropertiesFilters = this._ch.generateCustomPropertyFilters(
        customProperties,
        definition,
        CustomPropertyVisibilityType.Company | CustomPropertyVisibilityType.Property
      );
      this._ch.createCustomPropertyColumnDefinition(
        customProperties,
        this.columnDefinition,
        CustomPropertyVisibilityType.Company | CustomPropertyVisibilityType.Property
      );
      this.filterDefinition = [...this.filterDefinition, ...customPropertiesFilters];
    });
  }
}
